import styled from "styled-components";

export const PriceBreakupContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
`;

export const PriceBreakupTitle = styled.div`
  margin-bottom: 12px;
`;

export const PriceItemSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d8d8d8;
  margin: 12px 0;
`;
